import React from 'react';

const PRESET_LABELS = {
  today: 'Today',
  yesterday: 'Yesterday',
  this_week: 'This week',
  last_week: 'Last week',
  this_month: 'This month',
  last_month: 'Last month',
  this_year: 'This year',
  custom: 'Custom range',
  all: 'All time',
};

const SELECT = 'rounded-lg border-gray-300 shadow-sm focus:border-primary-500 focus:ring-primary-500 sm:text-sm';
const LABEL = 'block text-xs font-medium text-gray-600 mb-1';

/**
 * Date range picker: preset + custom start/end, with an optional date-field
 * selector when the dataset exposes more than one date on its rows.
 */
const DateRangeControl = ({
  value,
  onChange,
  presets = [],
  dateFields = [],
  showFieldSelect,
  applied = null,
  compact = false,
  allowAll = true,
  defaultFieldLabel = null,
}) => {
  const v = value || { field: null, preset: 'this_month', start: null, end: null };
  const presetList = (presets.length ? presets : Object.keys(PRESET_LABELS)).filter((p) => allowAll || p !== 'all');
  const showField = showFieldSelect ?? dateFields.length > 1;

  const setStart = (start) => {
    const patch = { start: start || null };
    if (start && v.end && start > v.end) patch.end = start;
    onChange(patch);
  };
  const setEnd = (end) => {
    const patch = { end: end || null };
    if (end && v.start && end < v.start) patch.start = end;
    onChange(patch);
  };

  return (
    <div className={compact ? 'flex flex-wrap items-end gap-3' : 'space-y-3'}>
      {showField && (
        <div>
          <label className={LABEL}>Date field</label>
          <select className={SELECT} value={v.field || ''} onChange={(e) => onChange({ field: e.target.value || null })}>
            <option value="">Default ({defaultFieldLabel || dateFields[0]?.label || 'dataset date'})</option>
            {dateFields.map((f) => (
              <option key={f.id} value={f.id}>
                {f.label}
              </option>
            ))}
          </select>
        </div>
      )}
      <div>
        <label className={LABEL}>Period</label>
        <select className={SELECT} value={v.preset} onChange={(e) => onChange({ preset: e.target.value })}>
          {presetList.map((p) => (
            <option key={p} value={p}>
              {PRESET_LABELS[p] || p}
            </option>
          ))}
        </select>
      </div>
      {v.preset === 'custom' && (
        <>
          <div>
            <label className={LABEL}>Start</label>
            <input type="date" className={SELECT} value={v.start || ''} max={v.end || undefined} onChange={(e) => setStart(e.target.value)} />
          </div>
          <div>
            <label className={LABEL}>End</label>
            <input type="date" className={SELECT} value={v.end || ''} min={v.start || undefined} onChange={(e) => setEnd(e.target.value)} />
          </div>
        </>
      )}
      {applied && (
        <p className="text-xs text-gray-500 self-center">
          Applied: {applied.start_local} – {applied.end_local}
          {applied.field ? ` on ${applied.field}` : ''}
        </p>
      )}
    </div>
  );
};

export default DateRangeControl;
